import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { MasterPlan } from '../../domain';
import { MasterPlansRepository } from '../../repositories';

@Injectable({ providedIn: 'root' })
export class GetPlanContainerByIdUseCase
  implements UseCase<string, MasterPlan>
{
  constructor(private readonly masterPlanRepository: MasterPlansRepository) {}

  execute(param: string): Observable<MasterPlan> {
    return this.masterPlanRepository.getMasterPlanById(param);
  }
}
